import React, { useEffect, useState } from "react";
import "../App.css";
import { getPolicies } from "../utilities/genesysCloudUtils";
import { Loading } from "./Loading";

function renderObject(obj, level = 0) {
  if (typeof obj !== "object" || obj === null)
    return <span>{String(obj)}</span>;
  if (Array.isArray(obj)) {
    return (
      <ul style={{ marginLeft: (level + 1) * 0.5 }}>
        {obj.map((item, idx) => (
          <li key={idx}>{renderObject(item, level + 1)}</li>
        ))}
      </ul>
    );
  }
  return (
    <ul style={{ marginLeft: (level + 1) * 0.5 }} key={level}>
      {Object.entries(obj).map(([key, value]) => {
        let displayKey;
        switch (key) {
          case "callPolicy":
            displayKey = "Call";
            break;
          case "chatPolicy":
            displayKey = "Chat";
            break;
          case "emailPolicy":
            displayKey = "Email";
            break;
          case "messagePolicy":
            displayKey = "Message";
            break;
          case "retainRecording":
            displayKey = "Retain Recording";
            break;
          case "deleteRecording":
            displayKey = "Delete Recording";
            break;
          case "alwaysDelete":
            displayKey = "Always Delete";
            break;
          case "retentionDuration":
            displayKey = "Retention Duration";
            break;
          case "archiveRetention":
            displayKey = "Archive Retention";
            break;
          case "deleteRetention":
            displayKey = "Delete Retention";
            break;
          case "initiateScreenRecording":
            displayKey = "Initiate Screen Recording";
            break;
          case "recordACW":
            displayKey = "Record After Call Work";
            break;
          case "assignSurveys":
            displayKey = "Assign Surveys";
            break;
          case "inviteTimeInterval":
            displayKey = "Invite Time Interval";
            break;
          case "sendingUser":
            displayKey = "Sending User";
            break;
          case "sendingDomain":
            displayKey = "Sending Domain";
            break;
          case "days":
            displayKey = "Days";
            break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          // case "":
          //   displayKey = "";
          //   break;
          case "selfUri":
          case "conditions":
          case "storageMedium":
            return null;
          case "actions":
            // Skip the "actions" label, but render its children
            return renderObject(value, -25);
          default:
            displayKey = key;
        }
        return (
          <li key={displayKey}>
            <strong>{displayKey}:</strong> {renderObject(value, level + 1)}
          </li>
        );
      })}
    </ul>
  );
}

export function Policies({
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  setOpts,
  doesPermExist,
  setIsVisible
}) {
  const [policies, setPolicies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  console.log("Policies doesPermExist", doesPermExist)

  useEffect(() => {
    generatePolicies();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    setTabName("policies-tab");
    setOpts({});
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const generatePolicies = () => {
    setIsLoading(true);
    getPolicies(doesPermExist)
      .then((data) => {
        setPolicies(data.entities);
        setPageCount(data.pageCount);
        console.log("Policies", data.entities);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching policies:", error);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <Loading loadingText="Loading policies..." />
      ) : (
        <>
          <div className="policy-status-row">
            <span className="status-badge-warning">Work in progress</span>
          </div>
          {policies &&
            policies.map((policy, index) => (
              <div className="card w-[35rem] shadow-sm policy-card" key={index}>
                <div className="card-body">
                  <h2 className="card-title">{policy.name}</h2>
                  <span className="text-sm">
                    Enabled:
                    {policy.enabled && <span className="code-active"> ✔</span>}
                  </span>
                  {policy.description && (
                    <p className="text-sm">{policy.description}</p>
                  )}
                  {policy.mediaPolicies && (
                    <div>
                      <strong>Media Policies:</strong>
                      {renderObject(policy.mediaPolicies)}
                    </div>
                  )}

                  <kbd className="kbd">{policy.id}</kbd>
                </div>
              </div>
            ))}
        </>
      )}
    </>
  );
}
